import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import { AllowBlockType } from '@openx/types/targeting/targeting.ts';
import { type JSX, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

type MetacategoryAllowBlockTypeDropdownProps = {
  allowBlockType: AllowBlockType;
  setAllowBlockType: (type: AllowBlockType) => void;
};

const options = Object.values(AllowBlockType);

export const MetacategoryAllowBlockTypeDropdown = ({
  setAllowBlockType,
  allowBlockType,
}: MetacategoryAllowBlockTypeDropdownProps): JSX.Element => {
  const { t } = useTranslation();

  const onChange = useCallback(
    (_event: React.SyntheticEvent, value: AllowBlockType) => {
      setAllowBlockType(value);
    },
    [setAllowBlockType]
  );

  return (
    <AutoComplete
      options={options}
      value={allowBlockType}
      onChange={onChange}
      disableClearable
      textFieldReadOnly
      fullWidth
      textFieldProps={{
        label: t('Allow / Block'),
      }}
      data-test="metacategory-intersect-type"
    />
  );
};
